<template>
  <v-data-table
    :headers="headers"
    :loading="!!!tilesGroups"
    :items="tilesGroups"
    :items-per-page="5"
    :sort-by="['default', 'name']"
    :sort-desc="[true, false]"
  >
    <template v-slot:item.default="{ item }">
      <v-checkbox
        class="d-inline-block"
        :input-value="item.default"
        readonly
      ></v-checkbox>
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-btn depressed small @click="$emit('edit', item)">{{
          $t('BUTTON.EDIT')
        }}</v-btn>
        <v-btn depressed small class="ms-2" @click="$emit('clone', item)">{{
          $t('BUTTON.CLONE')
        }}</v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'TilesGroupList',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    unwatch: null
  }),

  computed: {
    ...mapGetters('tile', {
      tilesGroups: 'GET_TILES_GROUPS'
    }),
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('TILES.ITEM_GROUP'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.DEFAULT'),
          value: 'default',
          align: 'center'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  },

  created() {
    this.setData();
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.setData();
        }
      }
    );
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    ...mapActions('tile', ['getTilesGroups']),
    setData() {
      this.getTilesGroups({ applicationId: this.id });
    }
  }
};
</script>
